import React, { Dispatch, SetStateAction } from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Box } from "@material-ui/core";
import ParameterValue from "../../api/models/test-series/ParameterValue";
import { tesaWhite } from "../../styles/colors";
import VerticalAlignedChip from "./VerticalAlignedChip";

export interface CustomSelectableChipProps {
  isSelected: boolean;
  parameterValue: ParameterValue;
  setSelected: Dispatch<SetStateAction<ParameterValue[]>>;
}

export const CustomSelectableChip: React.FC<CustomSelectableChipProps> = (props: CustomSelectableChipProps) => {
  const { isSelected, parameterValue, setSelected } = props;
  const { name } = parameterValue.parameter;
  const deselect = () =>
    setSelected((prevSelected) =>
      prevSelected.filter((prev) => prev.parameter.tmbId !== parameterValue.parameter.tmbId),
    );
  const select = () => setSelected((prevSelected) => [...prevSelected, parameterValue]);

  return (
    <>
      {isSelected ? (
        <VerticalAlignedChip
          clickable
          style={{ color: tesaWhite }}
          color="secondary"
          deleteIcon={
            <Box padding="0.17rem">
              <CheckCircleIcon style={{ fontSize: "1rem", color: tesaWhite }} />
            </Box>
          }
          label={name}
          onClick={deselect}
          onDelete={deselect}
        />
      ) : (
        <VerticalAlignedChip clickable color="primary" label={name} onClick={select} variant="outlined" />
      )}
    </>
  );
};
